import React from 'react';
import { useNetwork } from './NetworkContext';
import { truncateAddress } from './utils';
// import '../Navbar.css';

const Navbar = () => {
    const { network, walletAddress, setNetwork, setWalletAddress } = useNetwork();

    const handleSwitchNetwork = async () => {
        if (window.ethereum && window.ethereum.isMetaMask) {
            try {
                await window.ethereum.request({ method: 'wallet_requestPermissions', params: [{ eth_accounts: {} }] });
                setNetwork(null);
                setWalletAddress(null);
            } catch (error) {
                console.error('Failed to switch MetaMask network:', error);
            }
        } else {
            console.error('MetaMask is not installed');
        }
    };

    return (
        <nav className="navbar p-0 fixed-top d-flex flex-row">
                <div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
                    <a className="navbar-brand brand-logo-mini" href="/"><img src="{logoPath}" alt="logo" /></a>
                </div>
                <div className="navbar-menu-wrapper flex-grow d-flex align-items-stretch">
                    <button className="navbar-toggler navbar-toggler align-self-center" type="button" data-toggle="minimize">
                        <span className="mdi mdi-menu"></span>
                    </button>
                  

                    <ul className="navbar-nav navbar-nav-right">
                        <li className="nav-item dropdown">
                            <a className="nav-link" id="profileDropdown" href="#" data-toggle="dropdown">
                                <div className="navbar-profile">
                                {walletAddress ? (
                                    <>
                                        <span>Connected to {network?.toUpperCase()}: ({truncateAddress(walletAddress)})</span>
                                        <button onClick={handleSwitchNetwork}>Switch Network</button>
                                    </>
                                ) : (
                                    <span>Not connected</span>
                                )}
                                    {/* {currentAccount ? <p className="mb-0 d-none d-sm-block navbar-profile-name">{currentAccount}</p> : <a className="nav-link btn btn-primary create-new-button" id="createbuttonDropdown" data-toggle="dropdown" aria-expanded="false" href="#" onClick={connectWallet}>+ Connect Wallet</a>} */}
                                        
                                </div>
                            </a>
                        </li>
                       
                        {/* <li className="nav-item nav-settings d-none d-lg-block">
                            <a className="nav-link" href="#">
                                <i className="mdi mdi-view-grid"></i>
                            </a>
                        </li> */}

                    </ul>
                    <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" data-toggle="offcanvas" >
                        <span className="mdi mdi-format-line-spacing"></span>
                    </button>
                </div>
            </nav>
    );
};

export default Navbar;



